import React from 'react'
import {
    StyledBreachWallContent,
    StyledRegistrationInfo,
    StyledPackage,
    StyledButton,
} from './BreachWallContent.styled'
import { createLinkClickEvent } from '../../../../createLinkClickHandler'
import SubscriptionPackage, {
    SubscriptionPackageProps,
} from '../../../SubscriptionPackage/SubscriptionPackage'
import { AuthenticationProvider } from '../../../../../../user-registration/authentication/AuthenticationProvider'
import { BreachEvent } from '@news-mono/web-common'
import { useSelector } from 'react-redux'
import { AppState } from '@news-mono/web-common'
import { AuthenticationState } from '@news-mono/web-common'
import { THEWEST_ALL } from '../../../../../../user-registration/entitlements/common'

export interface BreachWallContentProps {
    title: () => JSX.Element | null
    terms: () => JSX.Element | null
    mediaBanner: () => JSX.Element | null
    subscriptionPackages?: SubscriptionPackageProps[]

    breachCreativeName: string
    breachDeal: string
    articleId: string | undefined
    onEvent: (event: BreachEvent) => void
}

export const BreachWallContent: React.FC<BreachWallContentProps> = ({
    title,
    subscriptionPackages,
    articleId,
    breachCreativeName,
    breachDeal,
    onEvent,
    mediaBanner,
    terms,
}) => {
    const { entitlements, isLoggedIn } = useSelector<
        AppState,
        AuthenticationState
    >((state) => state.authentication)

    const renderMediaBanner = mediaBanner
    const renderTitleSection = title
    const renderTerms = terms

    // a returning user is a user who has registered, logged in, and has not completed a purchase
    const returningUser = isLoggedIn && !entitlements?.includes(THEWEST_ALL)

    return (
        <AuthenticationProvider onEvent={onEvent}>
            {({ createBreachSubscribeClickEvent }) => (
                <StyledBreachWallContent>
                    {renderMediaBanner()}
                    <StyledRegistrationInfo>
                        {renderTitleSection()}

                        <StyledButton
                            onClick={() => {
                                createLinkClickEvent(
                                    breachCreativeName,
                                    breachDeal,
                                    onEvent,
                                )()
                                createBreachSubscribeClickEvent({
                                    articleId,
                                    breachCreativeName,
                                    breachDeal,
                                    returningUser,
                                })()
                            }}
                        >
                            View All Packages
                        </StyledButton>
                        {renderTerms()}
                    </StyledRegistrationInfo>
                    <StyledPackage>
                        {subscriptionPackages &&
                            subscriptionPackages.map(
                                (subscriptionPackageItem, index) => {
                                    return (
                                        <SubscriptionPackage
                                            key={index}
                                            articleId={articleId}
                                            breachCreativeName={
                                                breachCreativeName
                                            }
                                            breachDeal={breachDeal}
                                            onEvent={
                                                subscriptionPackageItem.onEvent
                                            }
                                            ribbonTitle={
                                                subscriptionPackageItem.ribbonTitle
                                            }
                                            pretitle={
                                                subscriptionPackageItem.pretitle
                                            }
                                            heading={
                                                subscriptionPackageItem.heading
                                            }
                                            price={
                                                subscriptionPackageItem.price
                                            }
                                            originalPrice={
                                                subscriptionPackageItem.originalPrice
                                            }
                                            priceQualifier={
                                                subscriptionPackageItem.priceQualifier
                                            }
                                            offerCode={
                                                subscriptionPackageItem.offerCode
                                            }
                                            packageTheme={
                                                subscriptionPackageItem.packageTheme
                                            }
                                            packagePath={
                                                subscriptionPackageItem.packagePath
                                            }
                                            packageType={
                                                subscriptionPackageItem.packageType
                                            }
                                        />
                                    )
                                },
                            )}
                    </StyledPackage>
                </StyledBreachWallContent>
            )}
        </AuthenticationProvider>
    )
}
BreachWallContent.displayName = 'BreachWallContent'

export default BreachWallContent
